import { List, ListProps } from "./List";

import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Home/Watchlist/WatchList";
import { cn } from "utils";
import { rootStore } from "@/src/store";
import { useMemo } from "react";
import { useSnapshot } from "valtio/react";

const I18n = I18nUtil.createScoped(Translations);

interface WatchListProps {
  type: "crypto" | "stock";
  data?: ListProps["data"];
  className?: string;
  source?: "recommend" | "favorite";
}

export const WatchList = (props: WatchListProps) => {
  const { data, className, type, source } = props;
  const {
    isLoading: isLoginLoading,
    isFetching,
    isLoggedIn,
  } = useSnapshot(rootStore.login);
  const title = useMemo(() => {
    if (isLoginLoading || isFetching) {
      return "";
    }
    if (!isLoggedIn || source === "recommend") {
      return I18n.t("Create Portfolio");
    }
    return I18n.t("Portfolio");
  }, [isLoginLoading, isLoggedIn, isFetching, source]);

  if (Array.isArray(data) && !data.length) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex flex-col gap-3 rounded-3 p-4 bg-background_white_overlay5",
        className,
      )}
    >
      <h3
        aria-label="Watch List h3"
        data-openreplay-label="Watch List h3 Semantic"
        id="sem-watch-list-h3"
        className={cn("title_l text-content_primary", {
          "w-31 h-6 bg-background_white_overlay5": isLoginLoading || isFetching,
        })}
      >
        {title}
      </h3>
      <List data={data} type={type} />
    </div>
  );
};
